<dialog id="{{ modalId }}" class="modal modal-top sm:modal-middle" (click)="onBackdropClick($event)">
  <div class="modal-box w-full max-w-lg p-6 relative rounded-2xl">
    <button class="btn btn-sm btn-circle btn-ghost absolute right-2 top-2" (click)="closeModal()">✕</button>

    <div class="py-4">
      <div class="relative flex flex-col items-center">
        <div
          class="w-36 h-36 mb-4 bg-error"
          style="
            mask: url('/icons/bi-solid-error.svg') no-repeat center / contain;
            -webkit-mask: url('/icons/bi-solid-error.svg') no-repeat center / contain;
          "
        ></div>

        <div class="w-full text-center">
          <h2 class="text-lg font-bold text-primary mb-2">
            You have unsaved changes.<br />
            What would you like to do?
          </h2>
        </div>
        <div class="flex justify-between gap-3 w-full mt-6 border-t border-base-300 pt-4">
          <button
            class="w-[200px] h-9 rounded border border-base-300 bg-base-100 text-sm font-medium text-base-content hover:bg-base-200 transition-colors disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap"
            (click)="onCloseWithoutSaving()"
          >
            Continue without saving
          </button>
          <button
            class="w-[104px] h-8 rounded border border-base-300 bg-base-100 text-sm font-medium text-base-content hover:bg-base-200 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
            (click)="onSaveAndClose()"
          >
            Save
          </button>
        </div>
      </div>
    </div>
  </div>
</dialog>
